import React, {Fragment, useState} from 'react'
import {connect} from 'dva'
import {Link} from 'dva/router'
import moment from 'moment'
import {Alert, Button, DatePicker, Form, Icon, Input, InputNumber, Radio, Result, Spin, Tag, Upload} from 'antd'
import styles from "./index.module.less"
import {uploadUrl} from "../../utils/config"

const desc = "团体游客须提前二个工作日预约，同时认真真实填写以下表格信息，入园当日携上传的附件至团体购票窗口购买团体票，经专用通道检票入园。填写过程中如有疑问，可咨询园区经营策划部，电话021-37792288-867、819；"
const formItemLayout = {
  labelCol: {
    xs: {span: 24},
    md: {span: 4},
  },
  wrapperCol: {
    xs: {span: 24},
    md: {span: 20},
  },
}
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 12,
      offset: 11,
    },
  },
}

const required = {
  required: true,
  message: '不能为空！',
}

const maxLength = {
  max: 200,
  message: '不能超过200个字符',
}

const requireOptions = [
  {value: 1, name: '需要'},
  {value: 0, name: '不需要'},
]

function disabledDate(current) {
  return current && current < moment().endOf('day');
}

const namespace = 'groupapply'

const Component = ({
                     model,
                     loading,
                     dispatch,
                     form: {
                       getFieldValue,
                       getFieldDecorator,
                       validateFieldsAndScroll,
                     },
                   }) => {

  const {countDown, groupProperties, showSuccess, groupApplyNo} = model
  const formLoading = !!loading.effects[`${namespace}/submit`]
  const verifyCodeSending = !!loading.effects[`${namespace}/sendVerifyCode`]

  let buttonText = '获取验证码'
  if (verifyCodeSending) {
    buttonText = `正在发送...`
  }
  if (countDown > 0) {
    buttonText = `${countDown}秒后获取`
  }

  const [fileList, setFileList] = useState([])
  const uploaderProps = {
    action: uploadUrl,
    multiple: true,
    name: 'attachment',
    fileList,
    onChange({fileList}) {
      setFileList(fileList)
    }
  }

  const sendVerifyCode = () => {
    const mobile = getFieldValue('mobile')
    if (/^1[3456789][0-9]{9}$/.test(mobile) && countDown === 0 && !verifyCodeSending) {
      dispatch({
        type: `${namespace}/sendVerifyCode`,
        payload: getFieldValue('mobile')
      })
    }
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    validateFieldsAndScroll((errors, {
      travelDate,
      ...values
    }) => {
      if (errors) {
        return false
      }

      dispatch({
        type: `${namespace}/submit`,
        payload: {
          ...values,
          travelDate: travelDate.startOf('day'),
          attachmentInfoList: fileList.map(file => file.response)
        },
      })
    })
  }

  return (
    <div className={styles['page-submit']}>

      {showSuccess ?
        <Result
          status="success"
          title="团队申请提交成功！"
          subTitle={`申请编号：${groupApplyNo}`}
          extra={[
            <Button type="primary" key="console" href="/">
              返回首页
            </Button>,
            <Button key="apply" href="./group-apply">继续申请</Button>,
          ]}
        /> :
        <Fragment>
          <h1>
            团队申请
            <Link to="/group-apply/list">查看我的预约</Link>
          </h1>
          <Alert
            message="申请说明："
            type={"success"}
            description={desc}
          /> <Spin spinning={formLoading}>
          <Form {...formItemLayout} style={{marginTop: 20}} onSubmit={handleSubmit}>
            <Form.Item label="入园日期">
              {getFieldDecorator('travelDate', {
                rules: [
                  required,
                ],
              })(<DatePicker disabledDate={disabledDate} placeholder="请选择入园日期" style={{width: '100%'}}/>)}
            </Form.Item>
            <Form.Item label="团队名称">
              {getFieldDecorator('groupName', {
                rules: [
                  required,
                  maxLength,
                ],
              })(<Input placeholder="请输入团队名称"/>)}
            </Form.Item>
            <Form.Item label="团队性质">
              {getFieldDecorator('groupPropertyId', {
                rules: [
                  required,
                ],
              })(<Radio.Group>
                {groupProperties.map(({value, name}) => <Radio key={value} value={value}>{name}</Radio>)}
              </Radio.Group>)}
            </Form.Item>
            <Form.Item label="预计人数">
              {getFieldDecorator('peopleCount', {
                rules: [
                  required,
                ],
              })(<InputNumber min={1} max={99999} precision={0} placeholder="请输入预计人数" style={{width: '100%'}}/>)}
            </Form.Item>
            <Form.Item label="联系人姓名">
              {getFieldDecorator('contact', {
                rules: [
                  required,
                  maxLength,
                ],
              })(<Input placeholder="请输入联系人姓名"/>)}
            </Form.Item>
            <Form.Item label="定点导览">
              {getFieldDecorator('pointGuide', {
                rules: [
                  required,
                ],
              })(<Radio.Group>
                {requireOptions.map(({value, name}) => <Radio key={value} value={value}>{name}</Radio>)}
              </Radio.Group>)} 100元/次
            </Form.Item>
            <Form.Item label="标准线路导览">
              {getFieldDecorator('lineGuide', {
                rules: [
                  required,
                ],
              })(<Radio.Group>
                {requireOptions.map(({value, name}) => <Radio key={value} value={value}>{name}</Radio>)}
              </Radio.Group>)} 300元/次
            </Form.Item>
            {/*<Form.Item label="矿坑预约">*/}
            {/*  {getFieldDecorator('pitBooking', {*/}
            {/*    rules: [*/}
            {/*      required,*/}
            {/*    ],*/}
            {/*  })(<Radio.Group>*/}
            {/*    {requireOptions.map(({value, name}) => <Radio key={value} value={value}>{name}</Radio>)}*/}
            {/*  </Radio.Group>)}*/}
            {/*</Form.Item>*/}
            <Form.Item label="备注">
              {getFieldDecorator('notes', {
                rules: [
                  maxLength,
                ],
              })(<Input placeholder="请输入备注信息"/>)}
            </Form.Item>
            <Form.Item label="附件上传">
              {getFieldDecorator('attachments', {
                rules: [
                  required,
                ],
              })(<Upload {...uploaderProps}>
                <Button>
                  <Icon type="upload"/> 选择文件
                </Button>
              </Upload>)}
              需加盖公章文件上传,点击 <a href="/dist/团队预约申请单（样张）.docx" style={{textDecoration: "underline"}}>下载样张</a>
            </Form.Item>
            <Form.Item label="联系人手机">
              {getFieldDecorator('mobile', {
                rules: [
                  required,
                  {
                    pattern: /^1[3456789][0-9]{9}$/,
                    message: '请输入有效的手机号码',
                  }
                ],
              })(<Input placeholder="请输入联系人手机"/>)}
            </Form.Item>
            <Form.Item label="验证码">
              {getFieldDecorator('verifyCode', {
                rules: [
                  required,
                ],
              })(<Input placeholder="请输入验证码" suffix={<a onClick={sendVerifyCode}>{buttonText}</a>}/>)}
            </Form.Item>

            <Form.Item {...tailFormItemLayout}>
              <Button type="primary" htmlType="submit">
                确认提交
              </Button>
            </Form.Item>
          </Form>
        </Spin>
        </Fragment>
      }
    </div>
  )
}

export default connect(({groupapply, loading}) => ({
  loading,
  model: groupapply,
}))(Form.create()(Component))
